import { render, staticRenderFns } from "./PortalMoneyField.vue?vue&type=template&id=6a2095e3"
import script from "./PortalMoneyField.vue?vue&type=script&lang=ts"
export * from "./PortalMoneyField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports